<template>
  <div class="configuration-page">
    <template v-if="isAdmin()">
      <div class="fields-wrapper" data-type="configuration">
        <div class="search-wrapper">
          <b-input-group size="sm" class="search-bar">
            <b-input-group-prepend is-text class="search-bar-icon">
              <b-icon icon="search"></b-icon>
            </b-input-group-prepend>

            <b-form-input
              autocomplete="off"
              type="search"
              placeholder="Digita una voce da ricercare"
              size="sm"
              v-model="searchedTerms"
            >
            </b-form-input>
          </b-input-group>
        </div>
      </div>
      <div class="mt-3 no-res" v-if="!filteredSections.length">
        Non ci sono voci che corrispondono alla ricerca
      </div>
      <div class="my-3 reports-wrapper">
        <div
          class="form-card-wrapper"
          v-for="section in filteredSections"
          :key="section.header"
        >
          <b-card>
            <template #header>
              <b>{{ section.header }}</b>
            </template>
            <b-card-text>
              <div class="flex-container">
                <router-link
                  class="flex-item"
                  v-for="item in section.items"
                  :key="item.title"
                  :to="item.href"
                >
                  <div class="flex-item-inner-container">
                    <span class="info">
                      <span class="name">{{ item.title }}</span>
                      <b-icon icon="chevron-right" class="go"></b-icon>
                    </span>
                    <span class="description">{{ item.description }}</span>
                  </div>
                </router-link>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </div>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import { canModule, isAdmin } from "@/utils/permissions";

import { mapActions } from "vuex";

export default {
  data() {
    return {
      searchedTerms: null,
      sections: [
        {
          header: "Agenzia",
          items: [
            {
              title: "Anagrafica Agenzia",
              description:
                "Dati dell'agenzia: ragione sociale, sedi, riferimenti fiscali",
              href: { name: "agency_setups.index" },
            },
            {
              title: "Impostazioni",
              description:
                "Parametri operativi: contabilità, SEPA, integrazioni Lisapay e Lisabbina",
              href: { name: "agency_setups.edit2" },
            },
          ],
        },
        {
          header: "Contabilità",
          items: [
            {
              title: "Comparti Contabili",
              description: "Suddivisione contabile dell'agenzia",
              href: { name: "module.PROF.COMP" },
            },
            {
              title: "Forme di Pagamento",
              description: "Casse e modalità di incasso",
              href: { name: "module.PROF.CAGG" },
            },
            {
              title: "Causali contabili Movimenti Vari",
              description: "Causali dei movimenti non legati a titoli",
              href: { name: "various_accountings.index" },
            },
            {
              title: "Codici Documenti Contabili",
              description:
                "Codici di classificazione dei documenti di cassa",
              href: { name: "book_tags.index" },
            },
            {
              title: "Conti e Causali Cont. Giornaliera",
              description: "Conti e causali della contabilità giornaliera",
              href: { name: "treasury-cash-reference" },
            },
            {
              title: "Banche",
              description:
                "Conti correnti dell'agenzia, usati dai flussi SEPA",
              href: { name: "bank_accounts.index" },
              module: "module.PROF.SEPA",
            },
          ],
        },
        {
          header: "Compagnie",
          items: [
            {
              title: "Compagnie e Prodotti",
              description: "Compagnie, prodotti, scorpori e mandati",
              href: { name: "module.PROF" },
            },
            {
              title: "Compagnie Coass",
              description: "Compagnie partecipanti nelle coassicurazioni",
              href: { name: "insurer_participants.index" },
            },
          ],
        },
        {
          header: "Rete di vendita",
          items: [
            {
              title: "Produttori",
              description: "Produttori dell'agenzia",
              href: { name: "module.PROF.PRCO" },
            },
            {
              title: "Collaborazioni orizzontali",
              description: "Intermediari in collaborazione orizzontale",
              href: { name: "brokers.index1" },
            },
          ],
        },
        {
          header: "Utenti",
          items: [
            {
              title: "Profilazione Utenti",
              description: "Utenti, ruoli e permessi di accesso",
              href: { name: "users.index" },
            },
          ],
        },
        {
          header: "Personalizzazioni",
          items: [
            {
              title: "Campi Aggiuntivi",
              description:
                "Attributi personalizzati su anagrafiche e contratti",
              href: { name: "attributes.index" },
            },
            {
              title: "Template Note",
              description: "Testi predefiniti per le note",
              href: { name: "note_templates.index" },
            },
            {
              title: "Mappatura Importatori",
              description: "Tracciati dei file importati dalle compagnie",
              href: { name: "module.PROF.CONF" },
              module: "module.PROF.CONF",
            },
            {
              title: "eMessage",
              description: "Credenziali e consumi del servizio eMessage",
              href: { name: "emessage.index" },
            },
          ],
        },
      ],
    };
  },
  computed: {
    filteredSections() {
      const terms = (this.searchedTerms || "").trim().toLowerCase();
      return this.sections
        .map((section) => {
          // le voci che dichiarano un modulo le vede solo chi ce l'ha
          const visible = section.items.filter(
            (item) => !item.module || canModule(item.module)
          );
          if (!terms) return { ...section, items: visible };
          // se il nome della sezione corrisponde, tengo tutte le sue voci
          const items = section.header.toLowerCase().includes(terms)
            ? visible
            : visible.filter(
                (item) =>
                  item.title.toLowerCase().includes(terms) ||
                  item.description.toLowerCase().includes(terms)
              );
          return { ...section, items };
        })
        .filter((section) => section.items.length);
    },
  },
  methods: {
    isAdmin,
    ...mapActions("queue", ["notifyQueue"]),
  },
  created() {
    this.notifyQueue({
      text: "Configurazione",
      path: "",
      level: 1,
    });
  },
};
</script>

<style scoped>
.configuration-page {
  padding-left: 1rem;
  padding-right: 1rem;
}

/* barra di ricerca: stessi valori di components/reports/generated-reports/create.vue,
   ridichiarati qui perche' la' vivono in uno <style> non scoped di quel componente */
.search-bar {
  color: var(--color-text-muted);
  outline: none !important;
  box-shadow: none !important;
  border: none !important;
}

.search-wrapper {
  margin-top: 1rem;
  position: sticky;
  top: 0;
  padding: 6px;
  border-radius: var(--radius-md);
  border: 1px solid var(--gray-100);
  background: var(--gray-200);
  z-index: 1;
}

.flex-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  column-gap: 20px;
  row-gap: 20px;
  grid-auto-flow: row;
  padding: 0;
  width: 100%;
}

.flex-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  gap: 8px;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: var(--radius-lg);
  background: rgba(0, 0, 0, 0.05);
  padding: 6px;
  transition: background 0.2s linear, border-color 0.2s linear;
  text-decoration: none;
  color: inherit;
}

.flex-item:hover {
  background-color: rgba(0, 159, 227, 0.3);
  text-decoration: none;
  color: inherit;
}

.flex-item-inner-container {
  border-radius: 0.5rem;
  border: 1px solid #fff;
  background-color: #fff;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 12px;
  gap: 8px;
}

.flex-item .info {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: 8px;
}

.flex-item .name {
  font-weight: bold;
  color: #0061c9;
  line-height: 1.2em;
}

.flex-item .go {
  flex: 0 0 auto;
  color: #0061c9;
}

.flex-item .description {
  line-height: 1.2em;
  font-size: 13px;
}
</style>
